export default __webpack_public_path__ + "static/media/group-4.8d0d2dce.svg";